import webUtils from '../../utils/webUtils';
import _get from 'lodash/get';
import _isObject from 'lodash/isObject';

const StrapiUtils = {
  SectionCombine: content => {
    if (
      !_get(content, 'topBanner') ||
      !_get(content, 'topBanner.backgroundDesktop')
    )
      return content['sections'];
    let tmp = [];
    content['topBanner']['__component'] = 'product-page.top-banner';
    tmp.push(content['topBanner']);
    tmp = tmp.concat(content['sections']);
    return tmp;
  },
  getAnchor: value => {
    return value
      .toLowerCase()
      .replaceAll(' ', '_')
      .replace('&', '')
      .replace("'", '');
  },
  strapiHTMLTags: str => {
    if (!str || _isObject(str)) return '';
    return str
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/&nbsp;/g, '')
      .replace(/&amp;/g, '');
  },
  getTopBannerText: data => {
    if (!data)
      return {
        title: '',
        desc: '',
        image: '',
      };
    return {
      title: _get(data, 'title'),
      desc: _get(data, 'description'),
      image: webUtils.normalizeImageUrl(_get(data, 'backgroundMobile.data.attributes.url')),
    };
  },
  decodeHtmlEntities: html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  },
};

export default StrapiUtils;
